export default class BackoffStrategy {
    static TYPES = { exponential: "exponential" };
    static MAX_RETRIES = 2;
    maxRetries;
    type;
    retryCounter = 0;

    constructor(type, maxRetries = BackoffStrategy.MAX_RETRIES) {
        this.type = type;
        this.maxRetries = maxRetries;
    }

    static wait(ms) {
        return new Promise((res) => {
            setTimeout(res, ms);
        });
    }

    async next(e) {
        if (this.type === BackoffStrategy.TYPES.exponential) {
            this.retryCounter += 1;
            if (this.retryCounter >= this.maxRetries) {
                throw e;
            }
            await BackoffStrategy.wait(2 ** this.retryCounter * 10);
            return undefined;
        }
        throw new Error(`backoff type ${this.type} is not supported`);
    }
}
